import { getEnvironmentProps } from "../../utils/environment";
import { dmnIdentity } from "../../utils/dmnIdentity";
import { errorHandler, apiFetchNotOkHandler } from "../errorHandler";

type SetDiaryNoteResponse = {
  payload?: {
    notes: string;
  };
  notes?: string;
  status: number;
};
type SetDiaryNoteProps = {
  venueId?: string;
  diaryNoteDate: string;
  diaryNote: string;
};
export const setDiaryNote = async ({
  venueId,
  diaryNoteDate,
  diaryNote
}: SetDiaryNoteProps): Promise<SetDiaryNoteResponse | undefined> => {
  if (!venueId) {
    return undefined;
  }

  const token = await dmnIdentity.getAccessToken();
  const environmentVars = getEnvironmentProps(token);

  const paramsObj = {
    date: diaryNoteDate,
    notes: diaryNote
  };

  try {
    const response = await fetch(
      `${environmentVars?.CORE_API_BASE_URL}/venues/${venueId}/diary-notes`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(paramsObj)
      }
    );

    if (!response.ok) {
      apiFetchNotOkHandler(response, "Error setting diary note");
      return undefined;
    }

    return await response.json();
  } catch (error) {
    errorHandler(error, "Error setting diary note");
    return undefined;
  }
};
